<template>
  <base-card :projectID="projectID" :categoryID="categoryID" :storyType="storyType" :isMarginless="isMarginless" :isRowLoading="isRowLoading" :isPinnableRow="isPinnableRow" :pinnedProjects="pinnedProjects" :disableLink="disableLink" :isGroupProject="isGroupProject">
    <visibility-flags :project="project"></visibility-flags>
    <div class="project-image-container">
      <project-image :image="image" :isRowLoading="isRowLoading" :imageBackground="imageBackground" :isBlank="isBlank" :isVisible="isVisible" :projectAwards="project.awards" :imageOverlay="imageOverlay"/>
      <milestone-progress v-if="showMilestoneCount" :milestonePostCount="project.milestonePostCount" :completedPostCount="project.completedPostCount"/>
    </div>
    <resource-type :project="project" :from-search="false" :fairProject="true"></resource-type>
    <project-title :isRowLoading="isRowLoading" :isBlank="isBlank" :title="title" :elementID="elementID" :customLineClamp="lineClamp" />
    <information :isRowLoading="isRowLoading" :isBlank="isBlank">
      <owners :members="coOwners"/>
    </information>
  </base-card>
</template>

<script>
import BaseCard from './BaseCard'
import base from '../mixins/base'
import visibility from '@/mixins/visibility'
import ProjectTitle from '../UI/Title'
import Information from '../UI/Information'
import ProjectImage from '../UI/ProjectImage'
import User from '../UI/User'
import VisibilityFlags from '@/components/Cards/ProjectCards/UI/visibilityFlags'
import MilestoneProgress from '../UI/MilestoneProgress'
import Owners from '../UI/Isef/Owners'
import ResourceType from '../UI/ResourceType'
import breakpoints from '@/libs/breakpoints'
export default {
  name: 'FairProject',
  components: {
    ResourceType,
    BaseCard,
    ProjectTitle,
    Information,
    ProjectImage,
    User,
    VisibilityFlags,
    MilestoneProgress,
    Owners
  },
  props: ['projectID', 'categoryID', 'storyType', 'isMarginless', 'isRowLoading', 'isPinnableRow', 'pinnedProjects', 'disableLink', 'isGroupProject'],
  mixins: [base, visibility],
  computed: {
    showCategories: function () {
      return this.$isYSC || this.$isMake
    },
    showMilestoneCount: function () {
      return this.project.milestonePostCount && this.project.milestonePostCount !== 0 && !this.isOASJudge && (this.$route.fullPath === '/viewAll/?profile=mine' || this.$route.name === 'profile')
    },
    lineClamp: function () {
      return breakpoints.isTouch() ? 1 : 2
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.project-image-container {
  position: relative;
  height: 145px;
}
::v-deep .story-title {
  margin: 0.25rem 0.75rem;
}
::v-deep .resource-main-container {
  height: auto;
  min-height: auto;
  margin: 0.4rem 0.75rem 0 0.75rem;
}
::v-deep .story-owner {
  margin: 0 0.75rem 0.75rem 0.75rem;
  font-size: 0.8rem;
}
::v-deep .progress-container {
  bottom: 5px;
  right: 5px;
}
</style>
